<template>
  <div>
    <!-- <b-alert show variant="info" v-model="showNewDevice">{{ $t('video.new-device-connected') }}</b-alert> -->
    <base-dialog v-model="reconnectDialogVisible" :content="$t('video.on-client-disconnected')" :okFn="() => {}"></base-dialog>
    <div v-if="!loaded">
      <div class="preload-block">
        <loading-anim :active="!loaded" fullScreen :text="$t('loading-videosession')"></loading-anim>
      </div>
    </div>
    <div id="videoTemplate" v-else>
      <b-modal v-model="preconnecting" id="preconnecting" centered cancel-disabled no-close-on-esc
        no-close-on-backdrop hide-header-close :title="userIsProfessional ? $t('video.connecting') : $t('waitingProfessionalHeader')">
        <div v-if="connectivityErrors">
          <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;">
            <img width="96px" height="96px" alt="danger" src="/static-appopensalud/img/icons/danger-icon.svg" />
          </div>
          <div v-if="otLoggingError">
            <p class="text-danger text-center">
              <b>{{ $t('video-test.adblock-error') }}</b>
            </p>
          </div>
          <div v-else>
            <p class="text-danger text-center">
              <b>{{ $t('dialog-title-minimumRequisitesVideoTest') }}</b>
            </p>
            <br />
            <p class="text-danger errorPanel">
              <small>
                {{ $t('test-requisites') }}
              </small>
            </p>
          </div>
        </div>
        <div v-else>
          <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;"><img width="96px" height="96px"
            src="/static-appopensalud/img/icons/clock-icon-blue-fill.svg" /></div>
          <p v-if="!videoStarted" style="text-align: center">{{ userIsProfessional ? $t('video.wait-connecting-patient') : $t('waitingProfessionalBody') }}</p>
          <p v-else style="text-align: center">{{ $t('reconnectingProfessional') }}</p>
        </div>
        <template v-slot:modal-footer>
          <support-chat-button/>
        </template>
      </b-modal>      
      <base-dialog :visible="preHangUpState" :okFn="() => { hangUp() }"
      @toggle="preHangUpState = !preHangUpState"
      :content="$t('video.hang-up-are-you-sure-question')"></base-dialog>
      <b-modal id="sessionEnded-modal" v-model="patientSessionEnded" centered cancel-disabled no-close-on-esc
        no-close-on-backdrop hide-header-close hide-footer :title="$t('sessionEnded')">
        <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;"><img width="96px" height="96px"
            src="/static-appopensalud/img/icons/hangup-sessionend-icon-blue-fill.svg"></div>
        <p style="text-align: center" v-html="$t('sessionEndedBody')"></p>
        <div style="text-align: center">
          <base-button style="text-align: center" v-if="appointment && appointment.portal"
            variant="primary" @click="returnToWebapp()">
            {{ $t('dialog.ok-button') }}</base-button>
        </div>
      </b-modal>
      <error :customError="errorName" v-if="errorName"></error>
      <div v-else id="videoTemplate">
        <b-modal id="sessionEnded-modal" v-model="sessionEnded" centered cancel-disabled no-close-on-esc
          no-close-on-backdrop hide-header-close hide-footer :title="$t('sessionEnded')">
          <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;"><img width="96px" height="96px"
              src="/static-appopensalud/img/icons/hangup-sessionend-icon-blue-fill.svg"></div>
          <p style="text-align: center" v-html="$t('sessionEndedBody')"></p>
          <div style="text-align: center">
            <base-button style="text-align: center" v-if="appointment && appointment.portal"
              variant="primary" @click="returnToWebapp()">
              {{ $t('dialog.ok-button') }}</base-button>
          </div>
        </b-modal>
        <div id="video" v-show="!preconnecting">
          <div id="subscriber"></div>
          <div id="publisher"></div>
          <timer id="timer" v-if="!preconnecting && !sessionEnded && appointment"
						:id="appointment.id"
            :duration="appointment.duration" :startTime="videoSession.videoSessionStart"
            videoTooltip ref="timer"></timer>

          <div id="video-toolbar" v-if="!preconnecting">
            <slashable-icon img="/static-appopensalud/img/icons/camera-icon-blue-fill.svg" @click="toggleCamera" :popover="!camShared ? $t('enable-cam') : $t('disable-cam')" :slashed="!camShared"></slashable-icon>
            <slashable-icon img="/static-appopensalud/img/icons/mic-icon-blue-fill.svg" @click="toggleMute" v-b-tooltip.hover :popover="muted ? $t('enable-mic') : $t('mute-mic')" :slashed="muted"></slashable-icon>
            <slashable-icon class="d-none d-xl-inline-block" img="/static-appopensalud/img/icons/screen-icon-blue-fill.svg" @click="toggleScreenShare" :popover="screenShared ? $t('stop-share-screen') : $t('share-screen')" :slashed="screenShared"></slashable-icon>
            <div v-if="userIsProfessional">
              <img src="/static-appopensalud/img/icons/hangup-icon-red-fill.svg" class="rounded-btn toggled-red-btn" @click="preHangUpState = true" v-b-tooltip.hover
              :title="$t('hang-up-video')"/>
            </div>
            <div>
              <img src="/static-appopensalud/img/icons/refresh-icon-blue-fill.svg" class="rounded-btn d-none d-xl-inline-block" @click="refresh" :title="$t('refresh-label')" style="background-color: rgb(78, 140, 255); cursor: pointer;"/>
            </div>
          </div>

        </div>
        <beautiful-chat v-if="!preconnecting" :participants="chat.participants" :titleImageUrl="chat.titleImageUrl"
          :onMessageWasSent="sendMessage" :messageList="chat.messageList" :newMessagesCount="chat.newMessagesCount"
          :isOpen="chat.isChatOpen" :icons="chat.icons" :open="openChat" :showEmoji="false" :showEdition="false" :showDeletion="false"  :close="closeChat"
          :showFile="true" :showTypingIndicator="chat.showTypingIndicator" :showLauncher="true" :showCloseButton="true"
          :colors="chat.colors" :alwaysScrollToBottom="chat.alwaysScrollToBottom" :messageStyling="chat.messageStyling"
          :placeholder="$t('chat-placeholder')">
          <template v-slot:header>
            <span class="sc-header--title enabled">Chat</span>
          </template>
        </beautiful-chat>
        <video-sidebar v-if="$apiToken && !preconnecting"
          @source-device-changed="changeSourceDevices"></video-sidebar>
        <CoolLightBox :items="lightbox.items" :index="lightbox.index"
          @close="$store.commit('video/resetLightbox')"></CoolLightBox>
      </div>
    </div>
  </div>
</template>

<script>
import OT from '@opentok/client'
import CloseIcon from '@/components/vue-beautiful-chat/src/assets/close-icon.png'
import OpenIcon from '@/components/vue-beautiful-chat/src/assets/logo-no-bg.svg'
import CloseIconSvg from '@/components/vue-beautiful-chat/src/assets/close.svg'
import { db } from '@/indexedDB.js'
import VideoSidebar from '@/components/video-launcher/VideoSidebar'
import CustomError from '@/components/video-launcher/Error'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import { BAlert, BIconMic, BIconMicMute, BIconTv, BIconSlash, BIconCameraVideo, BIconCameraVideoOff, BIconstack, BTooltip, VBTooltip, BIconTelephoneFill, BModal, BButton, BIconArrowClockwise } from 'bootstrap-vue'
import Timer from '@/components/utils/Timer'
import LoadingAnim from '@/components/utils/LoadingAnim'
import BaseDialog from '../base/BaseDialog.vue'
import SlashableIcon from '@/components/base/ui/SlashableIcon.vue'
import { detectAnyAdblocker } from 'vue-adblock-detector'
import NetworkTest from 'opentok-network-test-js'
import VideoRepository from '@/repositories/VideoRepository'
import { SUPPORTED_SOUNDCARDS } from '@/constants/supportedSoundcards'
import { mapGetters, mapState } from 'vuex'
import { hideSmartsuppChat } from '@/helpers/ui.helpers'

export default {
  name: 'Video',
  components: {
    'loading-anim': LoadingAnim,
    VideoSidebar,
    CoolLightBox,
    BIconMic,
    BIconMicMute,
    BIconTv,
    BIconCameraVideo,
    BIconCameraVideoOff,
    BIconTelephoneFill,
    BIconstack,
    BIconSlash,
    BTooltip,
    VBTooltip,
    BModal,
    BButton,
    BIconArrowClockwise,
    BAlert,
    'error': CustomError,
    'timer': Timer,
    'base-dialog': BaseDialog,
    'support-chat-button': () => import('@/components/utils/SupportChatButton'),
    'slashable-icon': SlashableIcon
  },
  data () {
    return {
      showNewDevice: false,
      loading: true,
      session: {},
      publisher: null,
      subscriber: {},
      videoProperties: {
        resolution: '1280x720',
        framerate: 20
      },
      audioProperties: {
        volume: 50
      },
      preconnecting: true,
      streamCreated: false,
      sessionValid: false,
      professional: {},
      chat: {
        icons: {
          open: {
            img: OpenIcon,
            name: 'default'
          },
          close: {
            img: CloseIcon,
            name: 'default'
          },
          closeSvg: {
            img: CloseIconSvg,
            name: 'default'
          }
        },
        participants: [
        ],
        messageList: [
        ],
        newMessagesCount: 0,
        isChatOpen: false,
        showTypingIndicator: '',
        colors: {
          header: {
            bg: '#3238C4',
            text: '#ffffff'
          },
          launcher: {
            bg: '#3238C4'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#3238C4',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#eaeaea',
            text: '#222222'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        },
        alwaysScrollToBottom: true,
        messageStyling: true,
        file: {
          b64: null
        }
      },
      sessionEnded: false,
      errorName: null,
      loaded: false,
      preHangUpState: false,
      preConsolidateState: false,
      videoStarted: false,
      reconnectDialogVisible: false,
      connectivityErrors: false,
      otLoggingError: false
    }
  },
	watch: {
		// Hide smartsupp chat when it is loaded to avoid overlapping with normal chat
		'$store.state.smartsuppChatLoaded': function (val) {
			if (val) {
				hideSmartsuppChat()
			}
		}
	},
  computed: {
		...mapState('video', ['videoSession', 'opentok', 'appointment', 'muted', 'camShared', 'screenShared', 'smallToken', 'patient', 'audioDevices', 'videoDevices', 'lightbox']),
    ...mapGetters('session', [
			'userIsProfessional'
		]),
    patientSessionEnded () {
      return this.sessionEnded && !this.userIsProfessional
    },
    professionalSessionEnded () {
      return this.sessionEnded && this.userIsProfessional
    }
  },
  mounted () {
		setTimeout(() => { hideSmartsuppChat() }, 2000)
    const sessionToken = this.$route.params.token
    this.$store.commit('video/setSmallToken', sessionToken)
    this.$api.get(`VideoSmallToken/${sessionToken}`).then(async (response) => {
      if ((!response.data && response.response && response.response.data && response.response.data.exceptionType)) {
        this.handleServerError(response.response.data)
      } else if (response.data.status === 400) {
        this.handleServerError(response.data)
      } else {
        let videoSessionUser = response.data.data
        this.videoStarted = videoSessionUser.videoStarted
        if (!videoSessionUser.testLaunched && !this.userIsProfessional) {
          this.$router.push({ name: 'TestToken', params: { token: sessionToken } })
        } else {
          detectAnyAdblocker().then((detected) => {
            if (detected) {
              this.connectivityErrors = true
              this.otLoggingError = true
            } else {
              // Set video session related data
              this.professional = videoSessionUser.professional
              this.$store.commit('video/setPatient', videoSessionUser.patient)
              this.$store.commit('video/setAppointment', videoSessionUser.appointment)
              VideoRepository.createTestSession(sessionToken).then((response) => {
                const otNetworkTest = new NetworkTest(OT, {
                  apiKey: response.data.data.opentokKey,
                  sessionId: response.data.data.opentokSession,
                  token: response.data.data.opentokPublishToken
                })

                // Set opentok session
                this.$store.commit('video/setSessionOpentokToken', {
                  opentokSession: videoSessionUser.opentokSession,
                  opentokPublishToken: videoSessionUser.opentokPublishToken,
                  opentokKey: videoSessionUser.opentokKey
                })

                otNetworkTest
                .testConnectivity()
                .then((results) => {
                  if (!results.success) {
                    this.connectivityErrors = true
                    if (results.failedTests && results.failedTests[0] && results.failedTests[0].error && results.failedTests[0].error.name === 'LoggingServerConnectionError') {
                      this.otLoggingError = true
                    }
                  } else {
                    this.initVideoOnMounted(videoSessionUser)
                  }
                })
              })
            }
          })
        }
      }
    }).catch((error) => {
      this.handleServerError(error.response ? error.response.data : error.message)
    }).then(() => {
      this.loaded = true
    })
  },
  methods: {
    async initVideoOnMounted (videoSessionUser) {
      // Set video session
      this.$store.commit('video/setVideoSession', {
        idVideoSession: videoSessionUser.idVideoSession,
        idVideoUser: videoSessionUser.idVideoUser,
        videoSessionStart: videoSessionUser.videoSessionStart ? new Date(`${videoSessionUser.videoSessionStart}Z`) : null
      })

      // Create user session
      // launcherApiToken is by default web app api token, except for api users (external)
      await this.$store.dispatch('session/create', { token: this.$apiToken !== videoSessionUser.launcherApiToken ? videoSessionUser.launcherApiToken : this.$apiToken, loginInfo: null, reload: true })

      // Init hw devices for device dropdowns
      /* OT.getDevices((error, devices) => {
      if (window.$cookies.get('api_token') !== videoSessionUser.launcherApiToken) {
        window.$cookies.remove('api_token')
        window.$cookies.set('api_token', videoSessionUser.launcherApiToken)
        _this.$store.commit('video/setApiToken', videoSessionUser.launcherApiToken)
        /* axios.defaults.headers.common['Authorization'] = 'Bearer' + videoSessionUser.launcherApiToken */
      this.loaded = true
      this.$nextTick(() => {
        this.initializeSession()
        this.initializeChat()
      })
      OT.getDevices((error, devices) => {
        if (!error) {
          this.$store.commit('video/setVideoSource', devices.filter(d => d.kind === 'videoInput')[0])
          this.$store.commit('video/setAudioSource', devices.filter(d => d.kind === 'audioInput')[0])
        } else {
          this.handlerError(error)
        }
      })
    },
    goToErrorView (errorTitle, errorMsg, errorCode) {
      this.$store.commit('video/setError', errorCode)
      this.$router.push({name: 'Error', params: { lang: this.$i18n.locale }, query: { error_title: errorTitle, error_msg: errorMsg, token: this.smallToken }})
    },
    initDevices (deviceChange = false) {
      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then((stream) => {
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          const mappedDevices = devices.map((d) => {
            return {
              deviceId: d.deviceId,
              kind: d.kind,
              label: d.label,
              groupId: d.groupId
            }
          })
          this.$store.commit('video/setDevices', mappedDevices)
          if (this.publisher.getVideoSource() != null) {
            this.$store.commit('video/setSelectedVideoSource', this.publisher.getVideoSource())
          }
          if (this.publisher.getAudioSource() != null && !deviceChange) {
            if (!SUPPORTED_SOUNDCARDS.find(ss => this.publisher.getAudioSource().label.includes(ss))) {
              this.$store.commit('video/setSelectedAudioSource', this.publisher.getAudioSource())
            } else {
              for (const d of mappedDevices) {
                if (!SUPPORTED_SOUNDCARDS.find(ss => d.label.includes(ss))) {
                  this.$store.commit('video/setSelectedAudioSource', d)
                  break
                }
              }
            }
          }
          this.publisher.setAudioSource(this.$store.getters['video/getSelectedAudioSource'])
        })
      })
    },
    listenNewDevices () {
      navigator.mediaDevices.ondevicechange = (event) => {
        this.$store.commit('video/showVideoSidebarAlert', {
          type: 'info',
          message: `${this.$t('video.new-device-connected')}`
        })
        this.initDevices(true)
      }
    },
    publishSession: function (error) {
      if (error) {
        this.handleError(error)
      } else {
        this.session.publish(this.publisher, (error) => {
          if (error) {
            this.handleError(error)
          }
        })
      }
    },
    handleError: function (error) {
      if (error) {
        if (error.name === 'OT_USER_MEDIA_ACCESS_DENIED') {
          if (this.screenShared) {
            this.$store.commit('video/toggleShareScreen')
            this.initializePublisher()
            return
          }
          this.goToErrorView(error.name, error.message, 102)
        } else {
          this.goToErrorView(error.name, error.message, 101)
        }
        this.publisher.destroy()
        this.publisher = null
      }
    },
    handleServerError: function (error) {
      // error.data is associated user data to server exception
      this.errorName = error.exceptionType || 'UnknownError'
      if (error.data) {
        this.$store.commit('video/setAppointment', error.data.appointment)
      }
    },
    checkScreenSharing: function () {
      OT.checkScreenSharingCapability((response) => {
        if (!response.supported || response.extensionRegistered === false) {
          // This browser does not support screen sharing.
          alert('erro sharing')
        } else if (response.extensionInstalled === false) {
          // Prompt to install the extension.
          alert('erro sharing')
        } else {
          // Screen sharing is available. Publish the screen.
          this.initializePublisher({ source: 'screen', publish: true })
					this.$store.dispatch('video/sendSignalCommand', 'screenShared', true)
        }
      })
    },
    initializePublisher (args = { source: null, publish: false, audioSource: null }) {
      if (!document.getElementById('publisher')) {
        var publisherDiv = document.createElement('div')
        publisherDiv.setAttribute('id', 'publisher')
        document.getElementById('video').insertBefore(publisherDiv, document.getElementById('subscriber'))
      }
      const publishOptions = {
        insertMode: 'replace',
        width: '15%',
        height: '20%',
        showControls: false,
        buttonDisplayMode: 'off',
        mirror: false,
        fitMode: 'cover',
        publishAudio: !this.muted,
        publishVideo: this.camShared
      }

      if (args.source) {
        publishOptions.videoSource = args.source
      }

      if (args.audioSource) {
        publishOptions.audioSource = args.audioSource
      }

      this.publisher = OT.initPublisher('publisher', publishOptions, args.publish ? this.publishSession : this.handleError)
      this.$store.commit('video/setPublisher', this.publisher)

      this.publisher.on({
        accessDenied (event) {
          console.log('Denied webcam.')
        },
        streamCreated (event) {
          console.log('Publisher started streaming.')
        },
        streamDestroyed (event) {
          console.log(`Publisher stopped streaming. Reason: ${event.reason}`)
        },
        mediaStopped (event) {
          event.preventDefault()
          if (this.screenShared) {
            this.toggleScreenShare()
          }
        }
      })

      return this.publisher
    },
    initializeSession: function () {
      this.initializePublisher()
      this.session = OT.initSession(this.opentok.api_key, this.opentok.session_token)
      this.$store.commit('video/setOTSession', this.session)
      this.session.connect(this.opentok.publisher_token, (error) => {
        if (error) {
          this.handleError(error)
        } else {
          this.session.publish(this.publisher, (error) => {
            if (error) {
              this.handleError(error)
            } else {
              this.notifyProfessional()
            }
          })
        }
      })

      OT.addEventListener('exception', (event) => {
        console.log(`error${event}`)
      })

      this.session.on('streamCreated', (event) => {
        if (!document.getElementById('subscriber')) {
          var subscriberDiv = document.createElement('div')
          subscriberDiv.setAttribute('id', 'subscriber')
          document.getElementById('video').insertBefore(subscriberDiv, document.getElementById('publisher'))
        }
        this.session.subscribe(event.stream, 'subscriber', {
          insertMode: 'replace',
          width: '100%',
          height: '100%',
          showControls: false,
          buttonDisplayMode: 'off',
          resolution: this.opentok.resolution,
          frameRate: this.opentok.frameRate
        }, (error) => {
          this.streamCreated = true
          this.preconnecting = false
          this.waitingProfessional = false
          this.$store.state.sharedDialog.visible = false
					this.$nextTick(() => {
            /* if (_this.publisher.getAudioSource() != null) {
              _this.$store.commit('video/video/setSelectedAudioSourceId', _this.publisher.getAudioSource().id)
            } */
            this.initDevices()
            this.listenNewDevices()
					})
					this.handleError(error)
        })
      })

      // Chat msg received
      this.session.on('signal:command', (event) => {
        if (event.data.indexOf('hangUp') > -1) {
          this.endSession()
        } else if (event.data.indexOf('screenShared') > -1) {
          console.log('Screen shared')
        } else {
          if (event.data.indexOf('newDocument;') > -1) {
            try {
              var fileJSON = JSON.parse(event.data.split('newDocument;')[1])
              this.processNewChatMsg(event, fileJSON)
            } catch (e) {
              console.log(e)
            }
            this.$store.dispatch('video/loadDocumentsTable')
          } else if (event.data.split(':')[0] !== this.patient.name && event.data.toLowerCase() !== 'hangup') {
            this.processNewChatMsg(event)
          }
        }
      })

      this.session.on('connectionDestroyed', (event) => {
        this.reconnectDialogVisible = true
      })
      this.session.on('sessionReconnected', (event) => {
        this.reconnectDialogVisible = false
      })
    },
    notifyProfessional: function () {
      this.$api.get(`NotifyVideoSession/${this.$route.params.token}`).then((response) => {
        if (response) {
          console.log('Professional notified.')
        }
      })
    },
    sendMessage: async function (message) {
      const text = message.data.text
      message.data.meta = `${new Date().getHours()}:${new Date().getMinutes()}`
      if ((text && text.length > 0) && !message.data.file) {
				this.sendSignalMessage(message)
      }
      if (message.type === 'file') {
				/* this.addLoadingFileMessage(message.type) */
        this.$store.dispatch('video/uploadClinicalDocument', { file: message.data.file, fileType: 0 }).then((response) => {
          message.data.url = this.getFileDownloadUrl(response.data.data)
          // First send associated text and then file name in a separated msg
					this.sendSignalMessage(message)
          this.sendSignalMessage({
            data: {
              text: `Nuevo fichero ${message.data.file.name} añadido.`
            }
          }, false)
          this.$store.dispatch('video/sendSignalFileMessage', response.data.data)
					/* this.removeLoadingFileMessage(message.type) */
        })
      }
    },
    sendSignalMessage (message, saveMsg = true) {
      this.$store.dispatch('video/sendSignalMessage', {
				msg: message.data.text,
				callback: (error) => {
					if (error) {
						console.log('Error sending signal:', error.name, error.message)
					} else {
						if (saveMsg) {
							this.onMessageWasSent(message)
						}
					}
				}
			})
    },
    onMessageWasSent (message) {
      this.chat.messageList = [ ...this.chat.messageList, message ]
      db.addMessageToDb(message, message.data.file ? message.data.url : null)
    },
    openChat () {
      this.chat.isChatOpen = true
      this.chat.newMessagesCount = 0
    },
    closeChat () {
      this.chat.isChatOpen = false
    },
    processNewChatMsg (event, fileJSON = null) {
      if (!this.chat.participants.find(p => p.id === event.from.connectionId)) {
        this.chat.participants.push({ id: event.from.connectionId, name: event.data.split(':')[0], imageUrl: this.professional.photo })
      }

      const msg = {
        type: fileJSON ? 'file' : 'text',
        author: event.from.connectionId,
        data: {
          text: fileJSON ? 'Archivo compartido' : event.data,
          file: fileJSON ? {
            name: fileJSON.FileName,
            type: fileJSON.ContentType
          } : null,
          url: fileJSON ? this.getFileDownloadUrl(fileJSON.IdFile) : null,
          meta: `${new Date().getHours()}:${new Date().getMinutes()}`
        }
      }
      this.onMessageWasSent(msg)
      this.chat.newMessagesCount = this.chat.isChatOpen ? this.chat.newMessagesCount : this.chat.newMessagesCount + 1
    },
    getFileDownloadUrl (fileId) {
      return `${this.$api.defaults.baseURL}/Files/DownloadAppointmentFile?id=${fileId}${this.$apiToken ? (`&t=${this.$apiToken}`) : ''}`
    },
    async initializeChat () {
      let dbObj = await db.getDb(this.appointment.id)
      this.$store.commit('video/setDb', dbObj)
      let messages = await db.getMessagesFromDb()
      if (messages && messages.length > 0) {
        let firstProfMsg = messages.find(msg => msg.author !== 'me')
        if (firstProfMsg) {
          this.chat.participants.push({ id: firstProfMsg.author, name: this.professional.name, imageUrl: this.professional.photo })
        }
        this.chat.messageList.push(...messages)
      }
    },
    async endSession () {
      this.sessionEnded = true
      this.session.disconnect()
      this.publisher.destroy()
      this.session.unsubscribe(this.subscriber)
      this.session.unpublish(this.publisher)
      this.disableVideo()
      this.disableAudio()
      await db.deleteMessagesFromDb()
      this.$refs.timer.removeElapsedSeconds()
    },
    returnToWebapp () {
      this.$helpers.goToWebApp(`HomePaciente/#/appointments/review/${this.appointment.id}`, this.$apiToken, this.appointment.portal)
    },
    toggleMute () {
      this.publisher.publishAudio(this.muted)
      this.$store.commit('video/toggleVideoMute')
    },
    toggleCamera () {
      this.publisher.publishVideo(!this.camShared)
      this.$store.commit('video/toggleCameraShare')
    },
    disableVideo () {
      this.publisher.publishVideo(false)
    },
    disableAudio () {
      this.publisher.publishAudio(false)
    },
    toggleScreenShare () {
      if (this.screenShared) {
        this.publisher.destroy()
        this.initializePublisher({ publish: true })
      } else {
        this.checkScreenSharing()
      }
      this.$store.commit('video/toggleShareScreen')
    },
    changeSourceDevices (videoSourceId, audioSourceId) {
      if (videoSourceId) {
        this.publisher.setVideoSource(videoSourceId)
				this.$store.commit('video/setVideoSource', this.videoDevices.filter(d => d.deviceId === videoSourceId)[0])
        /* this.publisher.cycleVideo((device) => {
          if (videoSourceId === device.deviceId) {
            _this.$store.commit('video/setVideoSource', _this.$store.state.video.videoDevices.filter(d => d.deviceId === videoSourceId)[0])
            _this.publisher.destroy()
            _this.initializePublisher({ source: device.deviceId, publish: true })
          } else {
            _this.changeSourceDevices(videoSourceId, audioSourceId)
          }
        }) */
      }
      if (audioSourceId) {
        this.$store.commit('video/setAudioSource', this.audioDevices.filter(d => d.deviceId === audioSourceId)[0])
        this.publisher.setAudioSource(audioSourceId)
      }
    },
    hangUp () {
      this.$helpers.goToWebApp(`/appointments/go/${this.appointment.id}/true`, this.$apiToken, this.appointment.portal)
    },
    refresh () {
      window.location.reload()
    }
/* 		addLoadingFileMessage (fileId) {
			this.chat.messagesList = [ ...this.chat.messageList, { id: fileId, data: { text: this.$t('loading') } } ]
		},
		removeLoadingFileMessage (fileId) {
			this.chat.messagesList = this.chat.messagesList.filter(
				message => message.id !== fileId
			)
		} */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

/* body {
  background-color: #868e96 !important;
} */

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li:not(.page-item) {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}

#video {
    position: absolute;
    left: 0px;
    width: 100%;
    height: calc(100%);
    padding: 0px;
    margin: 0px;
}

#publisher {
  position: absolute;

  z-index: 100;

  @include tablets {
    width: 200px !important;
    height: 140px !important;
  }

  @include mobile {
    width: 120px !important;
    height: 80px !important;
  }
  
  @include media(desktop, tablets) {
    bottom: 2rem;
    left: 3rem;
  }

  @include mobile {
    top: 10px;
    left: 10px;
  }
  
  /* border: 1px solid white; */
	border-radius: $border-radius;
	box-shadow: $custom-shadow-bottom;
}

#subscriber {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: calc(100%);
    z-index: 0 !important;
}

.video-info {
  z-index: 10000; 
  left: 50%;
  bottom: 2%;
  transform: translateX(-50%);
  padding: 20px;
  position: absolute;
  background-color: rgba(255,255,255,0.9);
}

/deep/.sc-message-list p {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/deep/ .sc-message--text-content {
  margin: {
    top: .5rem;
    bottom: .5rem;
  }
}

.sc-chat-window {
  z-index: 2;
}

#video-toolbar {
  left: 50%;
	bottom: 2rem;

  div:not(:last-child) {
    margin-right: 25px;
  }
	@include media(mobile, tablets) {
		div:is(:nth-child(2n)) {
			margin-right: 0px !important;
		}
	}

  @include desktop {
    padding: 10px 30px;
  }
  
  @include media(tablets) {
    padding: 10px 20px;
  }

  /* border-radius: 40px; */
  /* background-color: #ffffffab; */
  /* box-shadow: @shadow; */
  display: inline-block;

  div {
    display: inline-block;
  }
  
  position: absolute;
  @include mobile {
    display: flex;

    div {
      display: table-cell;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
  
  
  transform: translate(-50%, 0);
}

.toggled-red-btn {
  background-color: #ff3b10;
  color: white;
}

#timer {
  position: absolute;

  @include media(desktop, tablets) {
    top: 25px;
    right: 25px;
  }
  
  @include mobile {
    top: 15px;
    right: 15px;
  }
}

.preload-block {
  position: absolute !important;
  margin: auto;
  top: 0; 
  left: 0; 
  bottom: 0; 
  right: 0;
  background-color: white;
  box-shadow: $custom-shadow;
}

#chatbotiframe {
  display: none;
}

#chatbotiframe {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/video-launcher/Video.vue